import React from 'react';
import {injectIntl} from 'react-intl';
import {fillChartOptions} from '../../../utils/analytics';
import FullscreenChart from './FullscreenChart';

export const buildSeries = (config, data, hints) => data.series.map((s, i) => ({
    data: s.data.map((value) => value || 0),
    name: s.name,
    dataLabels: {
        enabled: true,
        format: hints.absolute ? '{point.y:f}' : '{point.percentage:.1f}%',
    },
}));

const buildBarChartOptions = (config, data, hints, intl) => {
    const exportingChartOptions = {
        legend: {
            enabled: true,
        },
    };

    return fillChartOptions({
        chart: {
            type: 'bar',
        },
        legend: {enabled: hints.printable},
        xAxis: {
            categories: data.categories,
            title: {enabled: false, text: config.title},
        },
        yAxis: {
            min: 0,
            title: {enabled: false},
            visible: false,
            reversedStacks: false,
        },
        plotOptions: {
            series: {
                stacking: hints.absolute ? 'normal' : 'percent',
            },
        },
        series: buildSeries(config, data, hints, intl),
        tooltip: {
            formatter: function() {
                return hints.absolute ?
                    `${this.series.name}: ${this.y} - ${this.x}` :
                    `${this.series.name}: ${this.percentage ? this.percentage.toFixed(2) : 0}% - ${this.x}`;
            },
        },
    }, config, data, hints, intl, exportingChartOptions);
};

const builders = {
    stackedBar: buildBarChartOptions,
};

const buildOptions = (config, data, hints, intl) => {
    if (builders[config.chart]) {
        return builders[config.chart](config, data, hints, intl);
    }
    return builders.column(config, data, hints, intl);
};

const SingleChoiceBattery = ({intl, data, params, hints}) => (
    <FullscreenChart hints={hints} options={buildOptions(params, data, hints, intl)} customLabel={`n=${data.count}`} />
);

export default injectIntl(SingleChoiceBattery);
